import z from 'zod';

export const post = {
  body: z.object({
    name: z.string().nonempty({ error: 'Supplier name is required' }),
    email: z.email({ error: 'Enter a valid email' }).nonempty({
      error: 'Supplier email is required',
    }),
    phone: z.string().nonempty({ error: 'Supplier phone is required' }),
    role: z.string().nonempty({ error: 'Supplier role is required' }),
    supplier: z.coerce.number().min(1, { error: 'Supplier id is required' }),
  }),
  response: z.array(
    z.object({
      id: z.number(),
      created_at: z.date(),
      updated_at: z.date(),
      name: z.string(),
      email: z.email(),
      phone: z.string(),
      role: z.string(),
      supplier: z.number(),
    }),
  ),
  params: z.object({
    supplier_id: z.coerce.number(),
  }),
  query: z.never(),
};
const postSchema = z.object(post);
export type Post = z.infer<typeof postSchema>;

const get = {
  body: z.never(),
  response: z.array(
    z.object({
      id: z.number(),
      created_at: z.date(),
      updated_at: z.date(),
      name: z.string(),
      email: z.email(),
      phone: z.string(),
      role: z.string(),
      supplier: z.number(),
    }),
  ),
  params: z.object({
    supplier_id: z.coerce.number(),
  }),
  query: z.never(),
};
const getSchema = z.object(get);
export type Get = z.infer<typeof getSchema>;

const put = {
  body: z.array(
    z.object({
      name: z.string().nonempty({ error: 'Supplier name is required' }),
      email: z.email({ error: 'Enter a valid email' }).nonempty({
        error: 'Supplier email is required',
      }),
      phone: z.string().nonempty({ error: 'Supplier phone is required' }),
      role: z.string().nonempty({ error: 'Supplier role is required' }),
      supplier: z.coerce.number().min(1, { error: 'Supplier id is required' }),
    }),
  ),
  response: z.array(
    z.object({
      id: z.number(),
      created_at: z.date(),
      updated_at: z.date(),
      name: z.string(),
      email: z.email(),
      phone: z.string(),
      role: z.string(),
      supplier: z.number(),
    }),
  ),
  params: z.object({
    id: z.coerce.number(),
  }),
  query: z.never(),
};
const putSchema = z.object(put);
export type Put = z.infer<typeof putSchema>;

const patch = {
  body: z
    .object({
      name: z.string(),
      email: z.email(),
      phone: z.string(),
      role: z.string(),
      supplier: z.number(),
    })
    .partial(),
  response: z.object({
    id: z.number(),
    created_at: z.date(),
    updated_at: z.date(),
    name: z.string(),
    email: z.email(),
    phone: z.string(),
    role: z.string(),
    supplier: z.number(),
  }),
  params: z.object({
    id: z.coerce.number(),
  }),
  query: z.never(),
};
const patchSchema = z.object(patch);
export type Patch = z.infer<typeof patchSchema>;

const remove = {
  body: z.never(),
  response: z.never(),
  params: z.object({
    id: z.coerce.number(),
  }),
  query: z.never(),
};
const deleteSchema = z.object(remove);
export type Delete = z.infer<typeof deleteSchema>;
